<div *ngIf="descriptor" [ngSwitch]="descriptor.controlType">

    <!-- common form controls -->
    <vedrax-control [descriptor]="descriptor" [control]="formComponent"></vedrax-control>

    <!-- handling dynamic form creation -->
    <vedrax-dynamic *ngSwitchCase="'arrayOfControls'" [descriptor]="descriptor" [form]="form"></vedrax-dynamic>

    <!-- handling matrix component -->
    <vedrax-matrix *ngSwitchCase="'matrix'" [descriptor]="descriptor" [form]="form"></vedrax-matrix>

    <!-- handling NVP component -->
    <vedrax-nvp *ngSwitchCase="'nvp'" [descriptor]="descriptor" [form]="form"></vedrax-nvp>

    <!-- handling multiple component -->
    <vedrax-multiple *ngSwitchCase="'multiple'" [descriptor]="descriptor" [form]="form"></vedrax-multiple>

    <!-- handling chips component -->
    <vedrax-chips *ngSwitchCase="'chips'" [descriptor]="descriptor" [form]="form"></vedrax-chips>

    <!-- handling upload component -->
    <vedrax-input-file *ngSwitchCase="'upload'" [descriptor]="descriptor" [form]="form"></vedrax-input-file>

    <!-- handling autocomplete component -->
    <vedrax-autocomplete *ngSwitchCase="'autocomplete'" [descriptor]="descriptor" [form]="form"></vedrax-autocomplete>

</div>